
import React, { useEffect, useState } from 'react'
import '../style.scss'
import { getAllInvoiceReserved, getMoadianLog, resendInvoice } from "../../../api/requestAxios/invoice";
import { ErrorToast, InfoToast } from "../../../shared";
import {  LogView, Note, Reload } from "../../../assets/images/svg/icon";
import { Info } from "@material-ui/icons"
import constants from '../../../constants/constants';
import ChangeReturnRevoke from '../revokeReturn/changeReturnRevoke';
import ModalInfo from './modalInfo';
import { getProvince } from '../../../api/requestAxios/userInfo';
import CustomValuesHook from '../../../functions/myHooks/CustomValuesHook';

import ModalLogMoadian from '../modalLogMoadian';




const ReservedInvoice = ({
    item,
    data,
    setData,
    setShow,
    setContent,
    setTitle,
    setviewDetail,
    type,
    setResendItemInLoading,
    resendItemInLoading

}) => {
    const [showLog, setShowLog] = useState(false)
    const [modalHeader, setModalHeader] = useState('')
    const [modalContent, setModalContent] = useState('')
    const [infoClick, setInfoClick] = useState(false)
    const [loading, setLoading] = useState(false)
    const [showModalInfo, setShowModalInfo] = useState(false)
    const [loadingModal, setLoadingModal] = useState(false)
    const [infoModal, setInfoModal] = useState({})

    const [infoForm, handleInfoForm] = CustomValuesHook({
        loading: false,
        provinceList: [],
        cityProvince: {},
        cityList: [],
        cityAndProvinceList: [],
        provLoading: false,
    })

    
    const createCityList = (cityAndProvinceList, provinceCityUser) => {

        if (cityAndProvinceList?.length > 0) {
            let cityListTemp = []

            cityAndProvinceList?.forEach((item, index) => {
                if (item?.Id === provinceCityUser?.provinceId) {
                    let objCity = {
                        cityName: item.CityName,
                        cityId: item.CityId,
                        provinceId: item?.Id
                    }

                    cityListTemp.push(objCity)
                }
            })
            handleInfoForm({ cityList: cityListTemp })
        }

    }

    const getProv = async (response) => {
        handleInfoForm({ provLoading: true })
        try {
            let preProvince;
            let provinceListTemp = [];
            let cityProvinceTemp = {};

            const listProvinceAndCity = await getProvince()
            listProvinceAndCity?.data?.map((item, index) => {
                //create province list
                if (preProvince !== item.ProvinceName && !item.Delete) {
                    provinceListTemp.push({
                        provinceName: item.ProvinceName,
                        provinceId: item.Id
                    })
                }
                preProvince = item.ProvinceName

                if (item?.CityId === response?.CityIdReservedOrReturned) {
                    cityProvinceTemp = {
                        cityName: item.CityName,
                        cityId: item.CityId,
                        provinceId: item?.Id,
                        provinceName: item?.ProvinceName
                    }
                }

            })
            handleInfoForm({
                cityAndProvinceList: listProvinceAndCity?.data,
                provinceList: provinceListTemp,
                cityProvince: cityProvinceTemp,
                provLoading: false
            })
            createCityList(listProvinceAndCity?.data, cityProvinceTemp)

        }
        catch (error) {
            handleInfoForm({
                provLoading: false
            })
            ErrorToast(error)
        }
    }



    const getData = async () => {
        setLoadingModal(true)
        try {
            const res = await getAllInvoiceReserved({ FactorId: item?.OfficialFactorId })
            let response = res?.data?.reservedOfficialFactorResponses[0]
            setLoadingModal(false)
            setInfoModal(response)
            getProv(response)
        }
        catch (error) {
            setLoadingModal(false)
            ErrorToast(error)
        }
    }
    //***************************************************************************** */
    const viewFactorFn = (e) => {
        if (item?.OfficialFactorId) {
            getData()
        }
        setShowModalInfo(true)
    }
    //************************************************************************************* */

    const resend = async () => {
        setLoading(true)
        setResendItemInLoading(item.idTable)
        try {
            const res = await resendInvoice(item?.OfficialFactorId)
            if (res.data.result) {
                InfoToast(res.data.message)
                setLoading(false)
            }
            else {
                ErrorToast(res.data.message)
                setLoading(false)
            }
            setResendItemInLoading('')

        }
        catch {
            setResendItemInLoading('')
            ErrorToast('سرور به مشکل مواجه است')
            setLoading(false)

        }

    }
    const infoViewFn = () => {
        setInfoClick(true)
        setModalHeader('خطای سامانه مودیان')
        setModalContent(item?.MoadianLog)
        setShowLog(true)
    }

    const handleClose = () => {
        setShowLog(false)
    }


    const logViewFn = () => {
        setInfoClick(false)
        setModalHeader('خروجی سامانه مودیان')
        getLogView()
    }

    const getLogView = async () => {
        setLoading(true)
        try {
            let obj = {}
            if (item.StatusEn === 'Reserved') obj.OfficialFactorId = item?.OfficialFactorId
            else obj.InvoiceId = item?.InvoiceId

            const res = await getMoadianLog(obj)
            if (res.data.ResultStatus === 1) {
                setModalContent(res.data?.moadianLogOutput?.MoadianHeader)
                setShowLog(true)
                setLoading(false)

            }
            else if (res.data.ResultStatus === 3) {
                ErrorToast(res.data.Message)
                setLoading(false)
            }


        }
        catch {
            setLoading(false)
            ErrorToast('سرور با مشکل مواجه است')
        }
    }


    return (
        <>

            {type === "status" && <div>
                {(item?.MoadianStatus !== null && item?.MoadianStatus !== '') && item?.MoadianStatus === 'SUCCESS' &&
                    <div className='d-flex justify-content-between movadian-accept-color'>
                        <span>تایید شده</span>
                        <span className='action-icon' onClick={() => { logViewFn() }}><LogView /></span>
                    </div>}
                {(item?.MoadianStatus !== null && item?.MoadianStatus !== '') && item?.MoadianStatus === 'FAILED' &&
                    <div className='d-flex justify-content-between movadian-reject-color'>
                        <span>رد شده</span>
                        <span className='action-icon' onClick={() => { logViewFn() }}><LogView /></span>
                        <span className='action-icon' onClick={() => { infoViewFn() }}><Info /></span>
                        {
                            <>
                                {resendItemInLoading !== item.idTable && <span onClick={() => resend(item?.InvoiceId)}><Reload /></span>}
                                {resendItemInLoading === item.idTable && <div className='table-context-invoice'>
                                    <div className='table-loading-invoice'>
                                        <div className="spinner-border" role="status" aria-hidden="true"></div>
                                    </div>
                                </div>}
                            </>
                        }

                    </div>}
                {(item?.MoadianStatus !== null && item?.MoadianStatus !== '') && (item?.MoadianStatus !== 'FAILED' && item?.MoadianStatus !== 'SUCCESS') &&
                    <div className='d-flex justify-content-between movadian-pending-color'>
                        <span>در حال بررسی</span>
                    </div>
                }
                {(item?.MoadianStatus === null || item?.MoadianStatus === '') && (item?.MoadianTaxId === null || item?.MoadianTaxId === '') &&
                    <>
                        {resendItemInLoading !== item.idTable &&
                            <div className='d-flex justify-content-center movadian-pending-color'>
                                <span>درانتطار بررسی</span>
                                <span className='action-icon' onClick={() => resend(item?.InvoiceId)}><Reload /></span>
                            </div>}
                        {resendItemInLoading === item.idTable && <div className='table-context-invoice'>
                            <div className='table-loading-invoice'>
                                <div className="spinner-border" role="status" aria-hidden="true"></div>
                            </div>
                        </div>}
                    </>
                }
            </div>}
            {
                !type && <div className='m-2'>
                    {item?.MoadianStatus === 'SUCCESS' && <ChangeReturnRevoke item={item} />}
                    <span onClick={(e) => { viewFactorFn(e) }}  ><Note /></span>
                </div>
            }


            {showLog &&
                <ModalLogMoadian
                    item={item}
                    showLog={showLog}
                    loading={loading}
                    modalContent={modalContent}
                    handleClose={handleClose}
                    modalHeader={modalHeader}
                    infoClick={infoClick}
                />}

            {showModalInfo && <ModalInfo
                fromPage="reserved"
                showModalInfo={showModalInfo}
                setShowModalInfo={setShowModalInfo}
                officialFactorId={item?.OfficialFactorId}
                loadingModal={loadingModal}
                infoModal={infoModal}
                createCityList={createCityList}
                infoForm={infoForm}
                handleInfoForm={handleInfoForm}
                item={item}


            />}

        </>
    )

}

export default ReservedInvoice